module.exports = __webpack_public_path__ + "img/icon-info-lilac.50b66a26.svg";